export default "__VITE_ASSET__B39Ydg7o__"